"use strict";

export function initInScope($scope) {
    /* add table-styling */
    let table = $scope.find('.wysiwyg table');

    table.wrap('<div class="table-responsive"></div>');
    table.addClass('table');
}
